import { render, staticRenderFns } from "./domaine-etienne-sauzet.vue?vue&type=template&id=1d22e1db&scoped=true"
import script from "./domaine-etienne-sauzet.vue?vue&type=script&lang=js"
export * from "./domaine-etienne-sauzet.vue?vue&type=script&lang=js"
import style0 from "./domaine-etienne-sauzet.vue?vue&type=style&index=0&id=1d22e1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22e1db",
  null
  
)

export default component.exports